import React, { Component } from "react";
import _ from "lodash";
import LoadSpinner from "./LoadSpinner";
import ImageWrapper from "components/ImageWrapper";
import { titleCase } from "sharedUtils/productUtils";
import MerchantRowMobile from "views/Account/AnalyticsByMerchantRowMobile";
import NoResults from "components/NoResults";


const { DateTime } = require("luxon");


class AnalyticsByMerchantTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: DateTime.utc().minus({ months: 1 }).startOf('day'),
            endDate: DateTime.utc().startOf('day'),
            tab: 1,
        };
    }

    componentDidMount = async () => {
        await this.props.resetPerformanceTabs();
        await this.props.getMerchantAnalytics(this.props.startDate, this.props.endDate);
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.userChanged != null && prevProps.userChanged != this.props.userChanged && this.props.userChanged) {
            await this.props.getMerchantAnalytics(this.props.startDate, this.props.endDate);
        }
        if (prevProps.aggregateChanged != null && prevProps.aggregateChanged !== this.props.aggregateChanged && this.props.display) {
            await this.props.getMerchantAnalytics(this.props.startDate, this.props.endDate);
        }
        if (prevProps.browseChanged != null && prevProps.browseChanged !== this.props.browseChanged && this.props.display) {
            await this.props.getMerchantAnalytics(this.props.startDate, this.props.endDate);
        }
    }


    displayMerchantMobile = () => {
        if (this.props.merchantAnalytics?.length === 0) {
            return (
                <div className="mt-3">
                    <NoResults />
                </div>
            )
        }

        const merchantData = {
            imageUrl: "",
            name: "",
            price: "",
            sale: "",
            salePrice: "",
            integrated: "",
            merchant: "",
            clicks: "clicks",
            sales: "sales",
            conversionRate: "conversions"
        };

        if (this.props.merchantAnalytics?.length > 0) {
            const analytics = [merchantData, ...this.props.merchantAnalytics];
            return analytics?.map((merchant, i) => {
                return (
                    <div key={i}>
                        <MerchantRowMobile
                            handleGetLink={this.props.handleGetLink}
                            merchant={merchant}
                            productKey={i}
                            key={i}
                            edit={() => { }}
                            hide={() => { }}
                            toggleProductModal={() => { }}
                            toggleShareModal={() => { }}
                            isUserMerchant={false}
                            editClick={() => { }}
                            hideClick={() => { }}
                            deviceSize={this.props.deviceSize}
                            handleSortSelect={this.props.handleMerchantSortSelect}
                            sortDescending={this.props.merchantSortDescending}
                            selectOptions={this.props.merchantSelectOptions}
                        />
                    </div>
                )

            })
        }
        return <></>;
    }

    displayTableHeader = () => {
        let headers = ["Merchant", "Clicks", "Sales", "Conversion"];

        return headers.map((header, i) => {
            const options = [
                { label: "Merchant", value: 1 },
                { label: "Clicks", value: 2 },
                { label: "Sales", value: 3 },
                { label: "Conversion Rate", value: 4 },
            ]

            if (header === "Merchant") {
                return (
                    <th key={i} onClick={() => this.props.handleMerchantSortSelect(options[0])} style={{ width: header === "Retail Price" ? "150px" : "", maxWidth: i === 0 ? "230px" : i === 1 || i === 2 ? "120px" : "", wordWrap: "break-word", cursor: "pointer", border: "none" }}>
                        <strong>{header}</strong>
                        <span className={`brand-nav-dropdown-toggle position-relative mr-2`} style={{ top: this.props.merchantSortDescending ? "-4px" : "9px", left: this.props.merchantSortDescending ? "" : "6px", }}>
                            <span className="brand-nav-chevron-iconset brand-nav-chevron-span" style={{ transform: this.props.merchantSortDescending ? "" : "rotate(180deg)" }}>
                                <svg aria-hidden="true" className="brand-nav-chevron-svg" fill="rgb(119,119,119)" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                                    <title>Expand</title>
                                    <path className={`brand-nav-lower-menu-hover${this.props.merchantSelectOptions.currentValue.label === "Merchant" ? "" : "-transparent"}`} d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                </svg>
                            </span>
                        </span>
                    </th>
                );
            } else if (header === "Clicks") {
                return (
                    <th key={i} onClick={() => this.props.handleMerchantSortSelect(options[1])} style={{ paddingLeft: "7px", width: header === "Retail Price" ? "150px" : "", maxWidth: i === 0 ? "230px" : i === 1 || i === 2 ? "120px" : "", wordWrap: "break-word", cursor: "pointer", border: "none" }}>
                        <strong>{header}</strong>
                        <span className={`brand-nav-dropdown-toggle position-relative mr-2`} style={{ top: this.props.merchantSortDescending ? "-4px" : "9px", left: this.props.merchantSortDescending ? "" : "6px", }}>
                            <span className="brand-nav-chevron-iconset brand-nav-chevron-span" style={{ transform: this.props.merchantSortDescending ? "" : "rotate(180deg)" }}>
                                <svg aria-hidden="true" className="brand-nav-chevron-svg" fill="rgb(119,119,119)" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                                    <title>Expand</title>
                                    <path className={`brand-nav-lower-menu-hover${this.props.merchantSelectOptions.currentValue.label === "Clicks" ? "" : "-transparent"}`} d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                </svg>
                            </span>
                        </span>
                    </th>
                );
            } else if (header === "Sales") {
                return (
                    <th key={i} onClick={() => this.props.handleMerchantSortSelect(options[2])} style={{ width: header === "Retail Price" ? "150px" : "", maxWidth: i === 0 ? "230px" : i === 1 || i === 2 ? "120px" : "", wordWrap: "break-word", cursor: "pointer", border: "none" }}>
                        <strong>{header}</strong>
                        <span className={`brand-nav-dropdown-toggle position-relative mr-2`} style={{ top: this.props.merchantSortDescending ? "-4px" : "9px", left: this.props.merchantSortDescending ? "" : "6px", }}>
                            <span className="brand-nav-chevron-iconset brand-nav-chevron-span" style={{ transform: this.props.merchantSortDescending ? "" : "rotate(180deg)" }}>
                                <svg aria-hidden="true" className="brand-nav-chevron-svg" fill="rgb(119,119,119)" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                                    <title>Expand</title>
                                    <path className={`brand-nav-lower-menu-hover${this.props.merchantSelectOptions.currentValue.label === "Sales" ? "" : "-transparent"}`} d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                </svg>
                            </span>
                        </span>
                    </th>
                );
            } else if (header === "Conversion") {
                return (
                    <th key={i} onClick={() => this.props.handleMerchantSortSelect(options[3])} style={{ width: header === "Retail Price" ? "150px" : "", maxWidth: i === 0 ? "230px" : i === 1 || i === 2 ? "120px" : "", wordWrap: "break-word", cursor: "pointer", border: "none" }}>
                        <strong>{header}</strong>
                        <span className={`brand-nav-dropdown-toggle position-relative mr-2`} style={{ top: this.props.merchantSortDescending ? "-4px" : "9px", left: this.props.merchantSortDescending ? "" : "6px", }}>
                            <span className="brand-nav-chevron-iconset brand-nav-chevron-span" style={{ transform: this.props.merchantSortDescending ? "" : "rotate(180deg)" }}>
                                <svg aria-hidden="true" className="brand-nav-chevron-svg" fill="rgb(119,119,119)" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
                                    <title>Expand</title>
                                    <path className={`brand-nav-lower-menu-hover${this.props.merchantSelectOptions.currentValue.label === "Conversion Rate" ? "" : "-transparent"}`} d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                                </svg>
                            </span>
                        </span>
                    </th>
                );
            } else {
                return (
                    <th key={i} style={{ paddingLeft: "12px", width: header === "Retail Price" ? "150px" : "", maxWidth: i === 0 ? "230px" : i === 1 || i === 2 ? "120px" : "", wordWrap: "break-word", border: "none" }}>
                        <strong>{header}</strong>
                    </th>
                );
            }
        });
    };


    displayTableRows = () => {
        if (this.props.merchantAnalytics?.length > 0) {
            return this.props.merchantAnalytics.map((merchant, i) => {
                let getLinkUrl = "https://";
                if (window.location.host.includes("app.rockp") && !!merchant.shareSubdomain) {
                    getLinkUrl += merchant.shareSubdomain + ".rockporch.com";
                } else {
                    getLinkUrl += window.location.host;
                }

                getLinkUrl = getLinkUrl + "/mlink/" + merchant.merchantId + "?userId=" + merchant.userId;

                return (
                    <tr key={i} className="hover-background"
                        onMouseEnter={() => this.setState({ hoverRow: i })}
                        onMouseLeave={() => this.setState({ hoverRow: -2 })}
                        style={{ cursor: "pointer", borderBottom: this.state.hoverRow === i + 1 ? "1px solid gray" : "" }}
                        onClick={() => this.props.handleGetLink(getLinkUrl)}
                    >
                        <td style={{ background: "white", maxWidth: "210px", wordWrap: "break-word", border: "none" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <ImageWrapper src={merchant.logoUrl} style={{ objectFit: "contain" }} />
                                <h6>{titleCase(merchant.merchant.trim())}</h6>
                            </div>
                        </td>

                        <td className="pr-5" style={{ textAlign: "center", maxWidth: "120px", wordWrap: "break-word", border: "none" }}>
                            <span>{merchant.clicks}</span>
                        </td>

                        <td className="pr-5" style={{ textAlign: "center", maxWidth: "120px", wordWrap: "break-word", border: "none" }}>
                            <span>{merchant.sales}</span>
                        </td>

                        <td className="pr-4" style={{ maxWidth: "120px", wordWrap: "break-word", border: "none" }}>
                            <span>{merchant.conversionRate}%</span>
                        </td>

                    </tr>
                )
            })
        }
    }

    render() {
        return (
            <>
                {
                    this.props.analyticsLoading ?
                        <LoadSpinner /> :
                        <section>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col" style={{ padding: "0" }}>

                                        {["sm", "md"].includes(this.props.deviceSize) ?
                                            this.displayMerchantMobile()
                                            :
                                            this.props.merchantAnalytics?.length === 0 ?
                                            <div className="mt-3">
                                                <NoResults />
                                            </div>   
                                            :
                                            <div className="table-responsive product-table" style={{ overflow: "visible" }}>
                                                <table className="table" style={{ border: 0 }}>
                                                    <thead>
                                                        <tr>
                                                            {this.displayTableHeader()}
                                                        </tr>
                                                    </thead>


                                                    <tbody>
                                                        {this.displayTableRows()}
                                                    </tbody>
                                                </table>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </section>
                }
            </>
        );
    }
}

export default AnalyticsByMerchantTable;